import * as React from 'react';
import { Fragment } from 'react';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { Link as RouterLink } from 'react-router-dom';
import { Link } from '@mui/material';
import Box from '@mui/material/Box';
import DashboardIcon from '@mui/icons-material/Dashboard';
import GridViewIcon from '@mui/icons-material/GridView';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import WalletIcon from '@mui/icons-material/Wallet';
import BarChartIcon from '@mui/icons-material/BarChart';
import SettingsIcon from '@mui/icons-material/Settings';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';

export default function Online() {
  const navItems = [
    {
      id: 'dashboard',
      label: 'Dashboard',
      icon: <DashboardIcon />,
      iconColor: '#ffc107', // Yellow
      route: '/'
    },
    {
      id: 'deposit',
      label: 'Deposit',
      icon: <ArrowDownwardIcon />,
      iconColor: '#4caf50', // Green
      route: '/receive'
    },
    {
      id: 'withdraw',
      label: 'Withdraw',
      icon: <AccountBalanceWalletIcon />,
      iconColor: '#4caf50', // Green
      route: '/send-coin'
    },
    {
      id: 'swap',
      label: 'Swap',
      icon: <SwapHorizIcon />,
      iconColor: '#03a9f4', // Light Blue
      route: '/swap-coin'
    },
    {
      id: 'assets',
      label: 'Assets',
      icon: <WalletIcon />,
      iconColor: '#ff6b35', // Orange/Red
      route: '/assets'
    },
    {
      id: 'transactions',
      label: 'Transactions',
      icon: <BarChartIcon />,
      iconColor: '#4caf50', // Green
      route: '/account-wallet'
    },
    {
      id: 'settings',
      label: 'Settings',
      icon: <SettingsIcon />,
      iconColor: '#ff6b35', // Orange
      route: '/settings'
    },
    {
      id: 'account',
      label: 'Account',
      icon: <AccountCircleIcon />,
      iconColor: '#ff6b35', // Orange
      route: '/profile'
    }
  ];

  return (
    <Fragment>
      <List sx={{ bgcolor: '#1a1a1a' }}>
        {navItems.map((item) => (
          <Link key={item.id} to={item.route} component={RouterLink} underline="none" color="inherit">
            <ListItem disablePadding>
              <ListItemButton>
                <ListItemIcon>
                  <Box
                    sx={{
                      color: item.iconColor,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: '24px'
                    }}
                  >
                    {item.icon}
                  </Box>
                </ListItemIcon>
                <ListItemText 
                  primary={item.label}
                  primaryTypographyProps={{
                    sx: { color: 'white', fontFamily: 'sans-serif' }
                  }}
                />
              </ListItemButton>
            </ListItem>
          </Link>
        ))}
      </List>
    </Fragment>
  );
}
